var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-overlay',{attrs:{"show":"","z-index":"1000"}},[_c('div',{ref:"content"},[_vm._t("default")],2),_c('div',{ref:"footer",staticClass:"copy-right"},[_c('copy-right-footer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }